(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinkypillow-pack-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-pack-builder')) {
    customElements.define('pp-pack-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.config = JSON.parse(this.querySelector('[data-pack-config]').textContent);
        this.form = this.querySelector('form');
        this.choices = [...this.querySelectorAll('.pp-pack__choice')];
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');
        this.review = this.querySelector('.pp-pack__review');
        this.format = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency });
        this.offerEligible = this.config.currency === 'USD' && this.config.country === 'US' && this.config.variants.every(v => v.price === 799);
        this.form.addEventListener('change', () => this.update());
        this.form.addEventListener('click', event => {
          const swatch = event.target.closest('[data-color-value]');
          if (!swatch || swatch.disabled || this.busy) return;
          swatch.closest('.pp-pack__choice').querySelector('select').value = swatch.dataset.colorValue;
          this.update();
        });
        this.form.addEventListener('submit', event => this.submit(event));
        this.update();
      }
      get size() { return Number(this.querySelector('input[type="radio"]:checked').value); }
      items() {
        const grouped = new Map();
        this.choices.slice(0, this.size).forEach(choice => {
          const id = Number(choice.querySelector('select').value);
          grouped.set(id, (grouped.get(id) || 0) + 1);
        });
        return [...grouped].map(([id, quantity]) => ({ id, quantity }));
      }
      bundle() {
        const key = this.choices.slice(0, this.size).map(choice => choice.querySelector('select').value).sort((a,b) => Number(a)-Number(b)).join(',');
        return this.config.bundles.find(bundle => bundle.key === key && bundle.size === this.size && bundle.price === this.config.prices[this.size]);
      }
      cartItems() {
        const bundle = this.bundle();
        return bundle ? [{id:bundle.id,quantity:1}] : [];
      }
      update() {
        this.choices.forEach((choice, index) => {
          const select = choice.querySelector('select');
          choice.hidden = index >= this.size;
          select.disabled = choice.hidden || this.busy;
          const variant = this.config.variants.find(item => String(item.id) === select.value);
          const image = choice.querySelector('img');
          if (variant) {
            image.src = variant.image; image.removeAttribute('srcset'); image.alt = variant.title;
            choice.querySelector('[data-choice-color]').textContent = variant.title;
          }
          choice.querySelectorAll('[data-color-value]').forEach(swatch => {
            const color = this.config.variants.find(v => String(v.id) === swatch.dataset.colorValue);
            swatch.setAttribute('aria-pressed', String(swatch.dataset.colorValue === select.value));
            swatch.disabled = choice.hidden || Boolean(this.busy) || !color?.available;
          });
        });
        const items = this.items();
        const valid = items.every(item => {
          const variant = this.config.variants.find(variant => variant.id === item.id);
          return variant?.available && item.quantity >= variant.min && item.quantity % variant.increment === 0 && (variant.max == null || item.quantity <= variant.max);
        });
        const total = items.reduce((sum, item) => sum + (this.config.variants.find(variant => variant.id === item.id)?.price || 0) * item.quantity, 0);
        const price = this.offerEligible ? this.config.prices[this.size] : total;
        const money = cents => this.format.format(cents / 100);
        this.querySelector('[data-total]').textContent = money(price);
        this.querySelector('[data-regular]').textContent = price < total ? money(total) : '';
        this.querySelector('[data-summary]').textContent = items.map(item => `${item.quantity} × ${this.config.variants.find(v => v.id === item.id).title}`).join(' · ');
        this.querySelector('[data-savings]').textContent = price < total ? this.config.strings.save.replace('[amount]', money(total - price)) : '';
        [2,3,4].forEach(size => {
          this.querySelector(`[data-tier-price="${size}"]`).textContent = this.offerEligible ? money(this.config.prices[size]) : '';
          this.querySelector(`[data-tier-saving="${size}"]`).textContent = this.offerEligible ? this.config.strings.save.replace('[amount]', money(799 * size - this.config.prices[size])) : '';
          this.querySelector(`[data-tier-each="${size}"]`).textContent = this.offerEligible ? this.config.strings.each.replace('[amount]', money(Math.round(this.config.prices[size] / size))) : '';
        });
        const activated = this.dataset.enabled === 'true' && this.dataset.backend === 'true' && this.dataset.shipping === 'true';
        const ready = activated && this.offerEligible && Boolean(this.bundle());
        this.querySelector('[data-preview-note]').hidden = activated;
        this.querySelector('[data-shipping-note]').textContent = !this.offerEligible ? this.config.strings.unsupported : this.dataset.shipping === 'true' ? this.config.strings.shippingReady : this.config.strings.shippingPreview;
        this.querySelector('[data-selection-note]').textContent = this.config.strings.choose;
        this.button.disabled = this.busy || !valid || !ready;
        this.button.textContent = this.busy ? this.config.strings.adding : !ready ? this.config.strings.unavailable : this.config.strings.add.replace('[count]', this.size);
        if (!this.busy) this.status.textContent = valid ? '' : this.config.strings.stock;
      }
      async submit(event) {
        event.preventDefault();
        if (this.button.disabled || this.busy) return;
        const items = this.cartItems();
        if (!items.length) return;
        this.busy = true;
        this.review.hidden = true;
        this.querySelectorAll('input[type="radio"]').forEach(input => { input.disabled = true; });
        this.form.setAttribute('aria-busy', 'true');
        this.update();
        let message;
        try {
          const root = window.Shopify?.routes?.root || '/';
          if (window.PinkyPillowBundles) {
            await window.PinkyPillowBundles.add(this.items());
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await response.json();
          if (!response.ok) {
            message = typeof data.description === 'string' ? `${data.description} ${this.config.strings.error}` : this.config.strings.error;
          } else {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
        } catch {
          message = this.config.strings.network;
        } finally {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.querySelectorAll('input[type="radio"]').forEach(input => { input.disabled = false; });
          this.update();
        }
        this.status.textContent = message;
        this.review.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
